import { makeStyles, Typography, Fade } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { transitionTimeout } from './../ClaimWizard';
import { ClaimContext } from '../../../../contexts/ClaimContext';
import { separations } from '../../../../constants/StyleConstants';
import MaterialTable from 'material-table';
import { defaultGridOptions, useGridColDefs } from '../../../../utils/GridUtils';
import { LoginContext } from '../../../../contexts/LoginContext';
import { AppContext } from '../../../../contexts/AppContext';
import ClaimsAPI from '../../../../services/ClaimsAPI';
import StCell from '../../../../components/StCell';

const useStyles = makeStyles(theme => ({
  ...separations,
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
}));

const PostedAndPendingBills = ({ data, loading, showActionMessage }) => {
  const colDefs = useGridColDefs([
    { title: 'Fecha factura', field: 'invoiceDate', brakeWhiteSpaceHeader: true, valueType: 'date' },
    { title: 'Referencia', field: 'reference' },
    { title: 'Doc. Compensación', field: 'clearingDocument', brakeWhiteSpaceHeader: true },
    { title: 'Fecha Vencimiento', field: 'expirationDate', brakeWhiteSpaceHeader: true, valueType: 'date' },
    { title: 'Tipo documento', field: 'docType', brakeWhiteSpaceHeader: true },
    { title: 'Importe', field: 'import', currencyRef: 'currency' },
    { title: 'Fecha pago', field: 'paymentDate', brakeWhiteSpaceHeader: true, valueType: 'date' },
    { title: 'Estado SAP', field: 'sapState', brakeWhiteSpaceHeader: true, valueRender: (value, rowData) => <StCell value={value === 'VERDE'} /> },
    { title: 'Estado', field: 'state' },
    { title: 'Area', field: 'area', hidden: true },
    { title: 'Accion', field: 'action', hidden: true },
  ]);

  return (
    <div style={{ width: '100%' }}>
      <MaterialTable {...defaultGridOptions} onRowClick={showActionMessage} columns={colDefs} data={data} isLoading={loading} />
    </div>
  );
};

const BillSelection = ({ setBillClaim }) => {
  const classes = useStyles();
  const { idSupplier } = useContext(LoginContext);
  const { showError } = useContext(AppContext);
  const { setStepElements, stepForward } = useContext(ClaimContext);
  const [transIn, setTransIn] = useState(true);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const step = {
      stepNumber: 1,
      backButtonText: 'Cancelar y elegir otro tipo de reclamo',
      transition: {
        enter: () => setTransIn(true),
        exit: () => setTransIn(false),
      },
    };

    setStepElements(step.stepNumber, step);

    setLoading(true);
    ClaimsAPI.getPendingAndAccounted(idSupplier)
      .then(res => setRows(res.data))
      .catch(error => showError('Error al cargar las facturas'))
      .finally(() => setLoading(false));
  }, []);

  const handleActionMessage = (event, rowData) => {
    setBillClaim(rowData);
    stepForward();
  };

  return (
    <Fade in={transIn} timeout={transitionTimeout} unmountOnExit>
      <div className={classes.root}>
        <Typography className={classes.bottomSeparation} variant="subtitle2">
          Seleccione una factura a derivar haciendo click en la fila correspondiente
        </Typography>
        <PostedAndPendingBills data={rows} showActionMessage={handleActionMessage} loading={loading} />
      </div>
    </Fade>
  );
};

export default BillSelection;
